import { Form as FormikForm } from 'formik';
import styled from 'styled-components/macro';
import {
  fontSize,
  fontWeight,
  layout,
  media,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';
import * as common from '../../common/elements/Form';

export const Form = styled(FormikForm)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  /* flex-start, not center, so overflowing content stays scrollable */
  justify-content: flex-start;
  width: calc(100% - 2 * ${layout.gutter});
  /* keep tall forms inside the viewport on small screens */
  max-height: calc(100vh - 2 * ${layout.gutter});
  overflow-y: auto;
  background: ${({ theme }) => theme.appBackground};
  border-radius: ${radius.lg};
  box-shadow: ${shadow.lg};
  ${common.ModalScreenWidthMQs}
`;

export const StudentList = styled.ul`
  width: 100%;
  max-width: 48rem;
  margin: ${space[3]} 0;
  padding: ${space[1]} ${space[4]};
  list-style-type: none;
  height: 50vh;
  overflow-y: auto;

  ${media.sm`
    width: 80%;
  `}
  ${common.HideScrollBars}
`;

export const StudentErrorMsg = styled.p`
  margin: ${space[2]} ${space[4]};
  text-align: center;
  font-size: ${fontSize.md};
  font-weight: ${fontWeight.medium};
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
